import { parqOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { profileKeys } from "./keys";
import { readSection, sectionMutation, sectionOptions, writeSection, } from "./section";
/**
 * The seven PAR-Q readiness answers (`D98`). `medicalNoticeShown` and
 * `positiveCount` are the server's; no screen derives them.
 */
const spec = {
    key: profileKeys.parq,
    name: "parq",
    output: parqOutput,
    path: TRAINING_ROUTES.parq,
};
/** `GET /me/parq`. */
export function fetchParq(api, init) {
    return readSection(api, spec, init);
}
/** `PUT /me/parq` — replaces the whole section; answers what is now stored. */
export function putParq(api, input) {
    return writeSection(api, spec, input);
}
export function parqOptions(api) {
    return sectionOptions(api, spec);
}
export function parqMutation(api) {
    return sectionMutation(api, spec);
}
//# sourceMappingURL=parq.js.map